export const clearFields = ($container) => {
    $container.find('select').val('');
    $container.find('input[type="text"]').val('');
    $container.find('input[type="number"]').val('');
    $container.find('input[type="checkbox"]').attr('checked', false);
}